import { createContext, type PropsWithChildren, useContext, useMemo } from 'react';

export type UIConfigContextData = {
  deviceType: 'DESKTOP' | 'TABLET' | 'MOBILE';
};

export const UIConfigContext = createContext<UIConfigContextData | undefined>(undefined);
UIConfigContext.displayName = 'UIConfigContext';

export const UIConfigProvider = ({ children, deviceType }: PropsWithChildren<UIConfigContextData>) => {
  const value = useMemo(() => ({ deviceType }), [deviceType]);

  return <UIConfigContext.Provider value={value}>{children}</UIConfigContext.Provider>;
};

export const useUIConfig = () => {
  const context = useContext(UIConfigContext);
  if (!context) {
    throw new Error('useUIConfig can only be used inside of UIConfigProvider');
  }

  return context;
};
